import { RichTextEditor as MantineRichTextEditor, RichTextEditorControlProps } from "@mantine/tiptap";
import clsx from "clsx";
import { FunctionComponent } from "react";
import styles from "../rich-text-editor.module.scss";
import { faItalic } from "@fortawesome/pro-solid-svg-icons";
import { Icon } from "../../icon";
import { useEditorDisabled } from "../use-editor-disabled";

const ItalicIcon = () => <Icon icon={faItalic} size="xs" />;

export const Italic: FunctionComponent<RichTextEditorControlProps> = ({ className, disabled, ...other }) => {
    const effectiveDisabled = useEditorDisabled(disabled);
    return (
        <MantineRichTextEditor.Italic
            className={clsx(styles["control"], className)}
            disabled={effectiveDisabled}
            {...other}
            icon={ItalicIcon}
        />
    );
};

Italic.displayName = "RichTextEditor.Italic";
